<template>
    <div class="b-border">
        <p class="d-flex align-items-center justify-content-between">
            <span class="mw-90"
                >{{ index + label + asterisk }}<small>{{ optional }}</small></span
            >
            <a class="right" @click="add" v-if="!$root.isMobile()">Anexar</a>
            <span v-if="$root.isMobile()">
                <img src="@/assets/images/icons/attach.svg" class="right mr-3" @click="add" />
                <img src="@/assets/images/icons/camera.svg" class="right" @click="addPicture" />
            </span>
        </p>
        <span v-for="(file, index) in uploadedFiles" :key="'uploaded-' + index" class="file">
            <div class="delete" @click="confirm(file, 'uploadedDocuments')"></div>
            {{ file.filename | formatDocumentName | limitName($root.isMobile()) }}
        </span>
        <small class="error text-danger" v-if="error">Formato do arquivo não suportado! Formatos aceitos: {{ supportedExtensions.join(", ") }}.</small>
        <small class="error text-danger" v-if="errorFile">Erro ao anexar arquivo.</small>
        <input type="file" ref="camera" @change="getPicture" style="display: none" accept="image/*" capture />
        <input type="file" ref="input" @change="changeFiles" style="display: none" :accept="supportedExtensions.join(',')" multiple />
    </div>
</template>
<script>
export default {
    name: "FilesComponent",
    props: ["label", "subLabel", "required", "files", "uploadedFiles", "fileType"],
    data() {
        return {
            errorFile: false,
            error: false,
            supportedExtensions: ["pdf", "docx", "doc", "jpg", "jpeg", "png"],
        };
    },
    methods: {
        add: function () {
            this.$refs.input.click();
        },
        addPicture: function () {
            this.$refs.camera.click();
        },
        remove: function (file) {
            this.files.splice(this.files.indexOf(file), 1);
        },
        confirm: function (file, type) {
            this.$store.commit("setConfirmForm", { form: this.$vnode.data.ref, key: file, type });
            this.$bvModal.show("modal-confirm");
        },
        getPicture: function () {
            this.error = false;
            const file = this.$refs.camera.files[0];

            const extension = file.name.split(".").pop();
            if (this.supportedExtensions.indexOf(extension) === -1) {
                this.error = true;
                return;
            }

            this.files.push(file);
        },
        changeFiles() {
            this.error = false;
            const files = Array.from(this.$refs.input.files);

            files.forEach((file) => {
                const extension = file.name.split(".").pop().toLowerCase();

                if (this.supportedExtensions.indexOf(extension) === -1) {
                    this.error = true;
                    return;
                }

                this.files.push(file);
            });

            this.$store
                .dispatch("sendFile", [files, this.fileType])
                .then((res) => {
                    if (!res) {
                        this.errorFile = true;

                        setTimeout(() => {
                             this.errorFile = false;
                        }, 3000);
                    }
                })
                .catch(() => {
                     this.errorFile = true;

                    setTimeout(() => {
                         this.errorFile = false;
                    }, 3000);
                });
        },
    },
    filters: {
        formatDocumentName: function (name) {
            if (name.indexOf("_") !== -1) {
                return name.split("_").slice(1).join("_");
            }
            return name;
        },
        limitName: function (name, mobile) {
            const limit = mobile ? 30 : 40;

            if (name.length > limit) {
                return name.substring(0, limit) + "...";
            }

            return name;
        },
    },
    computed: {
        index: function () {
            return this.$parent.$children.indexOf(this) + 1 + ". ";
        },
        asterisk: function () {
            return this.required ? "*" : "";
        },
        optional: function () {
            if (this.subLabel) {
                return `(${this.subLabel})`;
            }
            return !this.required ? "(se houver)" : "";
        },
    },
};
</script>
<style lang="scss" scoped>
span {
    color: #686361;
    font-family: "Nunito Sans";
    font-size: 16px;
    letter-spacing: 0;
    line-height: 22px;
}
a {
    color: #007bff;
    font-family: "Montserrat";
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 18px;
    text-align: right;
    cursor: pointer;
}
small {
    display: block;
    color: #c2c0bf;
    font-family: "Nunito Sans";
    font-size: 12px;
    letter-spacing: 0;
    line-height: 16px;
    max-width: 90%;
}
.file {
    display: block;
    width: 100%;
    background-color: #f6f6f6;
    border-radius: 15px;
    color: #32302f;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 18px;
    padding: 5px 25px;
    margin-bottom: 10px;
    position: relative;
}
.b-border {
    padding-bottom: 10px;
    margin: 30px 0;
    border-bottom: 1px solid #e7e7e7;
}
.delete {
    content: " ";
    top: 0px;
    right: 0px;
    width: 28px;
    z-index: 99;
    height: 100%;
    position: absolute;
    border-radius: 50%;
    background-color: #ed5417;
    cursor: pointer;
}

.delete::after {
    content: "−";
    color: white;
    position: absolute;
    font-weight: bold;
    margin-left: 0.6rem;
    margin-top: 0.35rem;
}

.mw-90 {
    max-width: 80%;
}

@media only screen and (max-width: 1024px) {
    span {
        font-size: 14px;
    }
    .delete::after {
        margin-left: 0.7rem;
    }
}
</style>
